import React from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import { MultiSelect } from 'react-multi-select-component';
import ClientService from '../../../../../Services/clientService';
import ErrorMessage from '../../../../ErrorMessage';
import stringHelper from '../../../../../Helpers/stringHelper';

export default class ClientMultiChoice extends React.Component {
  static defaultProps = {
    label: '',
    onChange: () => alert('ClientMultiChoice Onchange'),
    selected: [],
    fieldName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    ClientService.GetClientList()
      .then((result) => {
        let optValues = [];
        let selected = [];
        result.forEach((client) => {
          if (!!client.name) {
            const newValue = {
              label: client.name + stringHelper.toBracket(client.clientId),
              value: client.clientId,
            };
            optValues.push(newValue);
            if (this.props.selected && this.props.selected.some((x) => x.toString() == client.clientId.toString())) {
              selected.push(newValue);
            }
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected: selected,
        });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('CMC61');
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(selected.map((i) => i.value.toString()));
  }

  renderList() {
    return (
      <MultiSelect
        options={this.state.itemList}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className={'text-center arial w-100 text-center hover rounded arial m-1 p-1'}>
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
